import { render, staticRenderFns } from "./PrivateCatalog.vue?vue&type=template&id=1fbde291&"
import script from "./PrivateCatalog.vue?vue&type=script&lang=js&"
export * from "./PrivateCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports